import { render } from "./MyReportsBox.vue?vue&type=template&id=a79179d8&scoped=true"
import script from "./MyReportsBox.vue?vue&type=script&lang=js"
export * from "./MyReportsBox.vue?vue&type=script&lang=js"

import "./MyReportsBox.vue?vue&type=style&index=0&id=a79179d8&scoped=true&lang=css"

import exportComponent from "C:\\Users\\jhunr\\Documents\\Work\\GCM3\\repos\\talentsage2026_previous\\frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a79179d8"]])

export default __exports__